<template>
    <div class="logo-box" v-if="list && list.length>0">
        <div class="logo-title">
            <div class="line"></div>
            <div>{{title}}</div>
            <div class="line"></div>
        </div>
        <div class="image-list">
            <div v-for="(item, i) in list" :key="i" v-if="item.mobileImageUrl"  class="image-item">
                <a :href="item.link" v-if="item.link" target="_blank">
                    <img v-lazy="item.mobileImageUrl"/>
                </a>
                <img v-else v-lazy="item.mobileImageUrl"/>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name:'Logos',
    props:{
        mode:{
            type: Number,
            default:1
        }, 
        typeCode:{
            type: String,
            default: ''
        },
        title:{
            type: String,
            default:''
        }
    },
     watch:{
        typeCode:{
            handler:function(val, oldValue){
                console.log(val+'typeCode change');
                this.getBannerData();
            },
            deep: true,
            immediate: true
        }
    },
    data(){
        return {
            list:[]
        }
    },
    methods:{
        getBannerData(){
            const self = this;
            this.$http.get("/bicycle/inter/banners?type=" + this.typeCode).then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.list = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
    }
}
</script>

<style scoped>
.logo-box{
    width: 100%;
    margin: 0 auto;
    text-align: center;
    margin-top: 52px;
}
.logo-title{
    margin-bottom: 14px;
     font-size: 24px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
}
.image-item{
    margin-top: 10px;
    margin-bottom: 10px;
}
.image-single .image-item img{
    height: 60px;
}
.image-single .image-item{
    margin-left: 5%;
    margin-right: 5%;
}
.logo-title img{
    height: 20px;
}
.logo-title div{
    display: inline-block;
}
.line{
    width: 48px;
    height: 2px;
    background: black;
    margin-left: 12px;
    margin-right: 12px;
}
.image-list{
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: 5%;
    margin-right: 5%;
}
.image-list .image-item{
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    margin-left: 1%;
    margin-right: 1%;
}
.image-list .image-item img{
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/MobileLogos.vue